import type { ClickStatRow, PostDetail } from '@zen-bell/shared';

/**
 * The API base URL. Vite inlines VITE_API_URL at build time, so the image is
 * tied to one environment — the same trade-off Next makes with NEXT_PUBLIC_*.
 */
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Every admin call. `credentials: 'include'` sends the HttpOnly session cookie,
 * which is why the API must name this origin in its CORS allow-list.
 */
export async function adminFetch<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API_URL}${path}`, {
    ...init,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(init?.headers ?? {}) },
  });
  const body = (await res.json().catch(() => ({}))) as T & { message?: string };
  if (!res.ok) throw new Error(body.message || `Request failed (${res.status})`);
  return body;
}

export type { ClickStatRow, PostDetail };
